<template> 
    <!-- 特色资源  -->
    <div class="home-region resource">
        <div class="region-cont">
            <div class="tit tit-gray">特色资源 <div class="tit-bottom"></div></div>
            <p class="more" @click="toPage('resourcePage')">查看更多<i class="el-icon-d-arrow-right"></i></p>
            <ul class="resource-list">
                <li class="list" :class="item.mouseenter?'active':''" v-for="(item,index) in resourceList" :key="index" @mouseenter="animation_move(item)" > 
                    <div class="list-info"  :class="item.mouseenter?'info-move':'info-out'">   
                        <div class="info-img">
                            <img v-show='item.mouseenter' width="100%" height="100%" :src="item.imgHover" alt="">
                            <img v-show='!item.mouseenter' width="100%" height="100%" :src="item.img" alt="">
                        </div>
                        <p  class="info-tit "  v-show='!item.mouseenter'>{{ item.tit}}</p> 
                        <!-- 动画效果 -->
                        <div class="info animate__animated" v-show='item.mouseenter' :class="item.mouseenter?animateList[index]:''">
                            <div  class="info-list" >
                                <p v-for="(list,num) in item.list" :key="num" @click="toPage('resourceList',list)">{{list.val}}</p>
                            </div>
                            <p  class="info-tit" @click="toPage('resourceList',item)">{{item.txt}}</p> 
                        </div> 
                    </div>
                </li>
            </ul>  
        </div>
    </div>
</template>

<script>
import 'animate.css';
// import homeData from '../homeData.js';
import {resourceList} from '../../../io/api.js'
export default {
    data () {
        return {
            resourceList:[],//shomeData.resourceList,
            animateList:[
                'animate__flipInY',
                'animate__bounceInLeft',
                'animate__fadeInUp',
                'animate__zoomInUp',
                'animate__fadeInLeft',
                'animate__backInDown',
                'animate__rollIn',
                'animate__bounceIn'
            ]
        }
    },
    created(){
        this.getList()
    },
    methods: {
        async getList(){
            await resourceList().then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.resourceList=data.indexList;
                    //this.resourceList[0].mouseenter=true;
                    // this.resourceList.forEach((item,index)=>{
                    //     if(index>=1){
                    //         item.mouseenter=false;
                    //     }
                    // })
                }
            })
        },
        animation_move (item) { 
            this.resourceList.forEach(list => {
                list.mouseenter = false
            });
			item.mouseenter = true
		}, 
        // toMore(path){  
        //     let url= this.$router.resolve({
        //         path,//:'resourcePage',
        //         query:{
        //            changeflag:6
        //         },
        //     })  
        //     this.$windowOpen({ url:url.href,isLogin:true} )
        // },
        toPage(path,item){
            let query={
                changeflag:6,
            } 
            if(item){ 
                query.link=item.link;
                // query.table=item.table?item.table:(item.list&&item.list[0].table)||'';  
                if(item.table){
                    query.table=item.table; 
                    query.label=item.group||'';
                }
                if(item.tit){
                    query.word=item.tit; 
                    //query.table=item.list&&item.list[0].table||'';
                }
            } 
            let url= this.$router.resolve({
                path,
                query
            })  
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
    }
}
</script>

<style lang="less" scoped>
.resource{ 
    background: url('../../../assets/images/home/gray-page.png') no-repeat center;
    background-size: cover;
    .tit{
        margin-bottom: 0;
    }
    .more{
        width: 80px;
        margin: 8px auto 30px;
        font-weight: bold;
        font-size: 16px;
        color: #386DE8;
        line-height: 30px;
        cursor: pointer;
    }
    .resource-list{
        display: flex;
        justify-content: space-between;
        height: 550px;
        .list{
            width: 112px;
            height: 554px;
            &.active{
                width: 318px;
                height: 100%;
                .info-tit{
                    color: #fff;
                }
            }
        }
        .list-info {
            position: relative;
            width: 112px;
            height: 554px; 
            .info-img,.info{
                position: absolute;
                top:0;
                left: 0;
                width: 100%;
                height: 100%;
                .info-tit{
                    cursor: pointer;
                }
            } 
            .info-tit{
                position: absolute;
                bottom: 20px;
                font-weight: 500;
                font-size: 28px;
                color: #386DE8;
                line-height: 40px;
                text-align: center;
                width: 100%;
            }
            .info-list{
                width: 290px; 
                position: absolute;
                top:70px;
                left:14px;
                color: #fff;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin:0 auto;
                p{
                    width: 140px;
                    height: 48px;
                    line-height: 48px;
                    background: rgba(255,255,255,0.2);
                    border-radius: 4px;
                    border: 1px solid #FFFFFF;
                    text-align: center;
                    margin-bottom: 10px;
                    font-size: 16px;
                    cursor: pointer;
                    color: #FFFFFF;
                }
            }
        }
        .info-move {
            animation: myMou 0.5s; 
            height: 100%;
            animation-fill-mode: forwards;
        }

        .info-out {
            animation: myMou1 0.2s;
            animation-fill-mode: forwards;
        }
    } 
    @keyframes myMou {
        0% {
            width: 112px;
        }
        100% {
            width: 318px;
        }
    }
    @keyframes myMou1 {
        0% {
            width: 318px;
        }
        100% {
            width: 112px;
        }
    }  
}
</style>